// extracted by mini-css-extract-plugin
module.exports = {"Container":"Steps_Container__1FlSq","Vertical":"Steps_Vertical__3x0OC"};